var AbstractAuthenticationView = require("logon/AbstractAuthenticationView");
var Utils = require("common/Utils");

function ConnectionView() {
    AbstractAuthenticationView.call(this);

    var self = this;
    var $content = $(require("html!./connection_view.html"));

    /**
     * @abstract
     * @returns {jQuery} The jQuery element containing the content of this view
     */
    this.getContent = function() {
        return $content;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "Connection";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "authentication";
    };

    this.showConnectionFailure = function() {
        $("#starttitle").text($.t("common::api.failure.message"));
        $("#connectLoading").hide();
    };

    this.reset = function() {
        $("#starttitle").html("&nbsp;");
        $("#connectLoading").hide();
    };

    this.showConnecting = function() {
        $("#starttitle").html("&nbsp;");
        $("#connectLoading").show();
    };

    var super_show = this.show;
    this.show = function() {
        self.publishEvent("ConnectionController", "connect",
            {hostname : location.hostname + (window.location.port ? ":" + window.location.port : "")}
        );
        self.reset();

        super_show.call(this);

        self.publishEvent("ConnectionController", "check-in-progress");
    };
}

Utils.inherits(ConnectionView, AbstractAuthenticationView);

module.exports = ConnectionView;